import { SeoEnricherIntent } from '../../constants/seoEnricherIntents';

const ICON_BASE_PATH = '/seo-enricher-icons';

export const SEO_ENRICHER_DEFAULT_ICON = `${ICON_BASE_PATH}/default.svg`;

export const SEO_ENRICHER_INTENT_ICON_PATHS: Record<
  SeoEnricherIntent,
  string
> = {
  pricing_fare: `${ICON_BASE_PATH}/pricing_fare.svg`,
  fare_inclusions: `${ICON_BASE_PATH}/fare_inclusions.svg`,
  booking_process: `${ICON_BASE_PATH}/booking_process.svg`,
  booking_modification: `${ICON_BASE_PATH}/modify_cab_v2.svg`,
  cab_type_selection: `${ICON_BASE_PATH}/cab_type_selection_v2.svg`,
  luggage_capacity: `${ICON_BASE_PATH}/luggage_capacity.svg`,
  route_distance_duration: `${ICON_BASE_PATH}/multicity.svg`,
  toll_charges: `${ICON_BASE_PATH}/pricing_fare.svg`,
  night_travel: `${ICON_BASE_PATH}/night_travel_v2.svg`,
  airport_transfer: `${ICON_BASE_PATH}/airport_transfer.svg`,
  sightseeing_tourism: `${ICON_BASE_PATH}/sightseeing_tourism.svg`,
  safety_comfort: `${ICON_BASE_PATH}/safety_comfort.svg`,
  cancellation_refund: `${ICON_BASE_PATH}/cancellation_refund.svg`,
  waiting_time_policy: `${ICON_BASE_PATH}/waiting_time_policy.svg`,
  multi_stop_trip: `${ICON_BASE_PATH}/multicity.svg`,
  cab_comparison: `${ICON_BASE_PATH}/cab_comparison.svg`,
  group_travel: `${ICON_BASE_PATH}/group_travel_v2.svg`,
  driver_quality: `${ICON_BASE_PATH}/driver_quality_v2.svg`,
  driver_cab_assignment: `${ICON_BASE_PATH}/guaranteed_on_time.svg`,
  payment_options: `${ICON_BASE_PATH}/payment_options.svg`,
  general_inquiry: `${ICON_BASE_PATH}/general_inquiry.svg`
};

export const CIRCLE_INFO_ICON_PATH = `${ICON_BASE_PATH}/circle_info_v2.svg`;
export const getSeoEnricherIntentIconPath = (
  intent: SeoEnricherIntent | null
) =>
  intent ? SEO_ENRICHER_INTENT_ICON_PATHS[intent] : SEO_ENRICHER_DEFAULT_ICON;
